import Route from '@ember/routing/route';

export default class AuthenticatedTeamRoute extends Route {}
